'use strict';

require('../shell/includes.js');
require('../registration/appIncludes.js');
require('./app.js');
require('./controller.js');
require('./models/createAccount.js');
require('./models/cloneIntoAccount.js');
require('./views/landscapeCompanyTiles.js');
require('./views/body.js');
require('./views/signup.js');
require('./bootstrap.js');
